import { defineComponent, onMounted, reactive } from '@vue/composition-api';
import { Typography } from '../../parts';
import { useTitle } from '@/shared/hooks/useTitle';
import { useUser } from '@/shared/hooks/useUser';

type ReactiveData = {
  password: string;
};

export default defineComponent({
  components: { Typography },
  setup() {
    const { setTitle } = useTitle();
    const { login: loginAction } = useUser();

    const state = reactive<ReactiveData>({
      password: '',
    });

    onMounted(() => {
      setTitle({ title: '', icon: '' });
    });

    const login = () => {
      if (!state.password) return;
      loginAction({ password: state.password, is_admin: 1 });
    };

    const handleSubmit = (e: KeyboardEvent) => {
      if (e.keyCode === 13) {
        login();
      }
    };

    return {
      state,
      login,
      handleSubmit,
    };
  },
});
